import handleFloat from './handleFloat'

export default function handleRotate({ oldValue, newValue }) {
    if (isNaN(newValue) == false) {
        return handleFloat({ oldValue, newValue }) % 360
    }
    return oldValue
}